import React from 'react';
// We can reuse the Expertise component here to show services
import Expertise from '../components/Expertise';

const Services = () => {
  const styles = {
    header: {
      backgroundColor: 'var(--primary-dark)',
      color: 'var(--primary-light)',
      padding: '80px 20px',
      textAlign: 'center',
    },
    title: {
      fontSize: '3rem',
      marginBottom: '20px',
    },
    text: {
      fontSize: '1.2rem',
      maxWidth: '800px',
      margin: '0 auto',
      opacity: '0.9',
    }
  };

  return (
    <div>
      {/* Page Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>Our Services</h1>
        <p style={styles.text}>End-to-end solutions bridging the gap between physical infrastructure and digital intelligence.</p>
      </div>

      {/* Reusing the Expertise component for the main content */}
      <Expertise />
    </div>
  );
};

export default Services;